import { useState } from "react";
import api from "../api/axios";

export default function useUpdate(endpoint) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  const update = async (id, data) => {
    setLoading(true);
    setErrors(null);

    try {
      const response = await api.put(`${endpoint}/${id}`, data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        let backendErrors = {};
        error.response.data.errors.forEach((err) => {
          backendErrors[err.path || "general"] = err.msg;
        });
        setErrors(backendErrors);
        throw backendErrors;
      }

      const message =
        error.response?.data?.error || "Error al actualizar";
      setErrors({ general: message });
      throw { general: message };
    } finally {
      setLoading(false);
    }
  };

  return { update, loading, errors };
}
